import React from "react";
import {  useLoaderData } from "react-router-dom";
import { AiOutlineSwapRight } from "react-icons/ai";

const ProjectDetails = () => {
  const projectData = useLoaderData();
  const {
    image,
    project_name,
    description,
    bulletPoints,
    technology,
    showcase,
    url
  } = projectData;
  return (
    <div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="">
          <h1 className="text-3xl font-semibold">
            Project Name : {project_name}
          </h1>
          <h2 className="text-md lg:text-lg mb-8">{description}</h2>
          <h3 className="text-lg font-semibold">Functionalities :</h3>
          <ul>
            {bulletPoints.map((bulletpoint) => (
              <li className="text-md">
                <AiOutlineSwapRight className="inline mr-4" />
                {bulletpoint}
              </li>
            ))}
          </ul>
          <h2 className="text-lg font-semibold mt-8">Technologies used : </h2>
          <ul>
            {technology.map((tech) => (
              <li>
                <AiOutlineSwapRight className="inline mr-4" /> {tech}
              </li>
            ))}
          </ul>
          <a href={url} className="btn border-2 bg-neon text-black hover:text-white mt-8">Visit Website</a>
        </div>
        <div className="">
          <img src={image} className="mb-4 border-2 border-black" alt="" />
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {showcase.map((image) => (
              <img
                src={image}
                className="border-2 border-black"
                alt="project_image_screenshot"
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectDetails;
